import "@telemetry/appInsights";
import { Suspense } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { KeycloakProvider } from "@context/KeycloakProvider.tsx";
import { NavigationGuardProvider } from "@context/NavigationGuardContext.tsx";
import { NotificationProvider } from "@context/NotificationContext.tsx";
import { QueryClientProvider } from "@tanstack/react-query";
import { enGB } from "date-fns/locale";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { i18nReady } from "./i18n.ts";
import ThemeWrapper from "./ThemeWrapper.tsx";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/noto-kufi-arabic/600.css";
import "@fontsource/noto-kufi-arabic/700.css";
import "@fontsource/noto-kufi-arabic/800.css";
import "./index.css";
import { queryClient } from "./config/queryClient.ts";

i18nReady.then(() => {
  createRoot(document.getElementById("root")!).render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <KeycloakProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
            <Suspense fallback={<p>Loading translations…</p>}>
              <ThemeWrapper>
                <NotificationProvider>
                  <NavigationGuardProvider>
                    <App />
                  </NavigationGuardProvider>
                </NotificationProvider>
              </ThemeWrapper>
            </Suspense>
          </LocalizationProvider>
        </KeycloakProvider>
      </BrowserRouter>
    </QueryClientProvider>,
  );
});
